export const environment = {
  production: false,
  groupName: "CemSys_Users_DEV",
  apiUrl: "https://cemsys-api-dev-new.azure.chevron.com/api/v1",
  clientId: "fbabf222-892a-49be-ad55-4d032fc9b13f",
  tenantId: "fd799da1-bfc1-4234-a91c-72b3a1cb9e26",
  startYear: 2014,
  releaseDate: "07/13/2026",
  enableDeveloperMeasureOverride: false
};
